import React from 'react';
import { connect } from 'react-redux';
import api from '../data/api';

import * as AuthActions from "../data/auth/AuthActions";

class SetupRoute extends React.Component
{
    state = {
        loading: true
    };

    componentDidMount()
    {
        api.get('/sanctum/csrf-cookie').then(() => {
            this.props.fetchCurrentUser().then(user => {
                this.setState({loading: false});
            });
        });
    }

    render()
    {
        return this.state.loading ? null : this.props.children;
    }
}

const mapDispatchToProps = {
    fetchCurrentUser: AuthActions.fetchCurrentUser
};

export default connect(null, mapDispatchToProps)(SetupRoute);